import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { MUIDataTableMeta } from "mui-datatables";
import { FC, useEffect, useState } from "react";
import EmploymentAgenciesColumns from "../../../config/tableColumns/EmplyomentAgenciesColumns";
import { IEmplyomentAgency } from "../../../interfaces/EmploymentAgency";
import employmentAgenciesService from "../../../services/EmploymentAgenciesService";
import EmploymentAgenciesModal from "./EmploymentAgenciesModal";

const EmplyomentAgencies: FC<{}> = () => {

    const [agencies, setAgencies] = useState<IEmplyomentAgency[]>([]);
    const [currentAgency, setCurrentAgency] = useState<IEmplyomentAgency | undefined>(undefined)
    const [showModal, setShowModal] = useState(false);
    const [refresh, setRefresh] = useState(false);
    const [currentId, setCurrentId] = useState<number | undefined>(undefined);
    const [action, setAction] = useState('');

    const getAllAgencies = () => employmentAgenciesService.getAll().then(res => setAgencies(res))

    useEffect(() => {
        getAllAgencies()
    }, []);

    useEffect(() => {
        if (refresh === true) {
            getAllAgencies();
            setRefresh(false);
        }
    }, [refresh]);

    const onEditClick = (tableMeta: MUIDataTableMeta<IEmplyomentAgency>) => {
        if (tableMeta.rowData[0]) {
            employmentAgenciesService.get(tableMeta.rowData[0])
                .then(
                    res => {
                        setAction('edit')
                        setCurrentId(tableMeta.rowData[0])
                        setCurrentAgency(res)
                        setShowModal(true);
                    }
                )
        }
    }

    const onDeleteClick = (tableMeta: MUIDataTableMeta<IEmplyomentAgency>) => {
        if (tableMeta.rowData[0]) {
            setAction('delete')
            setCurrentId(tableMeta.rowData[0])
            setShowModal(true);
        }
    }

    return (
        <div className="container-fluid">
            <EmploymentAgenciesModal
                agency={currentAgency}
                id={currentId}
                show={showModal}
                close={(action?: string) => {
                    setShowModal(false);
                    setAction('')
                    setCurrentAgency(undefined);
                    setCurrentId(undefined);
                    if (typeof action === 'string')
                        setRefresh(true);
                }}
                action={action}
            />
            <div className="d-flex align-items-center justify-content-between mb-3">
                <h4 className="mb-0">Agenzie per il lavoro</h4>
                <button className='btn btn-success rounded-pill' onClick={() => { setShowModal(true); setAction('add') }}><FontAwesomeIcon icon={faPlus} className="me-1" />Crea agenzia</button>
            </div>
            <EmploymentAgenciesColumns agencies={agencies} onEditClick={onEditClick} onDeleteClick={onDeleteClick} />
        </div>
    )
}

export default EmplyomentAgencies;